<div class="gcontainer bwhite">
  <div class="row breadcrumb-header align-items-center sticky-header">
    <div class="col-md-8">
      <nav aria-label="breadcrumb" class="mt-8">
        <ol class="breadcrumb">
          <li class="breadcrumb-item active breadcrumb cursor" aria-current="page" (click)="reDirectUrl()" tabindex="0">
            Dashboard
          </li>
          <li class="breadcrumb-item active breadcrumb cursor" aria-current="page" (click)="backToWorksheet()" tabindex="0">
            Compaction
          </li>
          <li class="breadcrumb-item active" aria-current="page">History</li>
        </ol>
      </nav>
    </div>
    <div class="col-md-4 d-flex justify-content-end">
      <button mat-raised-button (click)="backToWorksheet()">
        <mat-icon>arrow_back</mat-icon>
        Back to Compaction
      </button>
    </div>
  </div>

  <div class="history-title">
    <h1 class="mat-h1">Compaction History@if (referenceId) {
      : {{ referenceId }}
    }</h1>
    @if (companyName || projectName) {
      <p>{{ companyName }}@if (companyName && projectName) {
        <span> - </span>
      }{{ projectName }}</p>
    }
  </div>

  @if (isLoading) {
    <p class="history-empty">Loading history...</p>
  }
  @if (!isLoading && events.length === 0) {
    <p class="history-empty">No changes have been recorded from the Compaction worksheet yet.</p>
  }

  @if (!isLoading && events.length > 0) {
    <app-history-timeline [events]="events" [(selectedIndex)]="selectedIndex"></app-history-timeline>
    <!-- SELECTED ACTION -->
    @if (selectedEvent; as event) {
      <div class="selected-event">
        <div class="selected-header">
          <span class="selected-time">
            {{ event.changedAt | utcToLocal: 'date' }} {{ event.changedAt | utcToLocal: 'time' }}
          </span>
          <span class="selected-user">{{ event.changedBy }}</span>
          <span class="selected-action" [class.assigned]="event.action === 'Assigned'">{{ event.action }}</span>
          <span class="selected-summary">
            {{ changedRowCount(event) }} of {{ event.rows.length }} row(s) changed@if (changedFieldCount(event) > 0) {
            <span>, {{ changedFieldCount(event) }} change(s)</span>
          }
        </span>
      </div>
      <table mat-table [dataSource]="event.rows" class="material-table custom-table history-table">
        <ng-container matColumnDef="sampleId">
          <th mat-header-cell *matHeaderCellDef>Sample Id</th>
          <td mat-cell *matCellDef="let row">{{ row.sampleId ?? '—' }}</td>
        </ng-container>
        <ng-container matColumnDef="effort">
          <th mat-header-cell *matHeaderCellDef>Compaction Effort</th>
          <td mat-cell *matCellDef="let row">{{ displayEffort(row) }}</td>
        </ng-container>
        <ng-container matColumnDef="depth">
          <th mat-header-cell *matHeaderCellDef>Depth</th>
          <td mat-cell *matCellDef="let row">{{ displayDepth(row) }}</td>
        </ng-container>
        <ng-container matColumnDef="inHouseId">
          <th mat-header-cell *matHeaderCellDef>In-House Id</th>
          <td mat-cell *matCellDef="let row" [class.changed-cell]="row.inHouseId.changed">
            <ng-container *ngTemplateOutlet="fieldCell; context: { $implicit: row.inHouseId, isStatus: false }"></ng-container>
          </td>
        </ng-container>
        <ng-container matColumnDef="mouldPlusProbeTare">
          <th mat-header-cell *matHeaderCellDef>Mold + Probe Weight</th>
          <td mat-cell *matCellDef="let row" [class.changed-cell]="row.mouldPlusProbeTare.changed">
            <ng-container *ngTemplateOutlet="fieldCell; context: { $implicit: row.mouldPlusProbeTare, isStatus: false }"></ng-container>
          </td>
        </ng-container>
        <ng-container matColumnDef="soilDiameter">
          <th mat-header-cell *matHeaderCellDef>Sample Diameter</th>
          <td mat-cell *matCellDef="let row" [class.changed-cell]="row.soilDiameter.changed">
            <ng-container *ngTemplateOutlet="fieldCell; context: { $implicit: row.soilDiameter, isStatus: false }"></ng-container>
          </td>
        </ng-container>
        <ng-container matColumnDef="tubeHeight">
          <th mat-header-cell *matHeaderCellDef>Sample Height</th>
          <td mat-cell *matCellDef="let row" [class.changed-cell]="row.tubeHeight.changed">
            <ng-container *ngTemplateOutlet="fieldCell; context: { $implicit: row.tubeHeight, isStatus: false }"></ng-container>
          </td>
        </ng-container>
        <ng-container matColumnDef="minus">
          <th mat-header-cell *matHeaderCellDef>Minus</th>
          <td mat-cell *matCellDef="let row" [class.changed-cell]="row.minus.changed">
            <ng-container *ngTemplateOutlet="fieldCell; context: { $implicit: row.minus, isStatus: false }"></ng-container>
          </td>
        </ng-container>
        <ng-container matColumnDef="weight">
          <th mat-header-cell *matHeaderCellDef>Actual Weight</th>
          <td mat-cell *matCellDef="let row" [class.changed-cell]="row.weight.changed">
            <ng-container *ngTemplateOutlet="fieldCell; context: { $implicit: row.weight, isStatus: false }"></ng-container>
          </td>
        </ng-container>
        <ng-container matColumnDef="tr">
          <th mat-header-cell *matHeaderCellDef>TR</th>
          <td mat-cell *matCellDef="let row" [class.changed-cell]="row.tr.changed">
            <ng-container *ngTemplateOutlet="fieldCell; context: { $implicit: row.tr, isStatus: false }"></ng-container>
          </td>
        </ng-container>
        <ng-container matColumnDef="geothermSoilDescription">
          <th mat-header-cell *matHeaderCellDef>Geotherm Soil Description</th>
          <td mat-cell *matCellDef="let row" class="description-cell" [class.changed-cell]="row.geothermSoilDescription.changed">
            <ng-container *ngTemplateOutlet="fieldCell; context: { $implicit: row.geothermSoilDescription, isStatus: false }"></ng-container>
          </td>
        </ng-container>
        <ng-container matColumnDef="isCompactionCompleted">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let row" [class.changed-cell]="row.isCompactionCompleted.changed">
            <ng-container *ngTemplateOutlet="fieldCell; context: { $implicit: row.isCompactionCompleted, isStatus: true }"></ng-container>
          </td>
        </ng-container>
        <ng-container matColumnDef="assignedTo">
          <th mat-header-cell *matHeaderCellDef>Assigned To</th>
          <td mat-cell *matCellDef="let row" [class.changed-cell]="row.assignedTo.changed">
            <ng-container *ngTemplateOutlet="fieldCell; context: { $implicit: row.assignedTo, isStatus: false }"></ng-container>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; let i = index; columns: displayedColumns"
          [class.changed-row]="row.changedInAction"
          [class.dotted-bottom-border]="isLastRowOfEffort(event.rows, i)"
        [class.bold-bottom-border]="isLastRowOfSample(event.rows, i)"></tr>
      </table>
    </div>
  }
}
</div>

<!-- Current value, plus the previous one struck through when the field changed -->
<ng-template #fieldCell let-field let-isStatus="isStatus">
  <span class="current-value">{{ displayValue(field.current, isStatus) }}</span>
  @if (field.changed) {
    <span class="previous-value">{{ displayValue(field.previous, isStatus) }}</span>
  }
</ng-template>
